import { React } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { formatPhoneNumber } from '../../../Utils/phoneUtils';
import { useLanguage } from '../../../Context/LanguageContext';

export default function WeeklyAbsenteeMemberList(props) {
  const { data, selectedPartnerGym } = props;

  const { t, languageMode } = useLanguage();

  // 생년월일 포맷 //
  function formatBirthDay(bd) {
    const y = bd.slice(0, 4), m = bd.slice(4, 6), d = bd.slice(6, 8);
    const order = t('statistics.calendar.dateOrder');
    const sep = t('statistics.calendar.dateSeparator');
    if (order === 'MDY') return m + sep + d + sep + y;
    return y + sep + m + sep + d;
  }
  const history = useHistory();

  // 전화번호 표시 //
  function calcPhone(viewData) {
    if (!viewData.phone || viewData.phone === '') return t('statistics.noPhone');
    return formatPhoneNumber(viewData.phone, viewData.countryCode, languageMode) || t('statistics.noPhone');
  }

  // 회원 정보 클릭시 //
  function onClickMemberInfo(data) {
    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) history.push('/member/valid/detail/' + data.memberId);
    else history.push('/member/partner_gym/detail/' + data.memberId);
    // () => history.push('/member/valid/detail/' + data.memberId)
  }

  return (
    <TopLevelWrapper>
      <Table>
        <Head>
          <HeadTr>
            <Td style={{ width: `68px`, marginLeft: '8px' }}>{t('statistics.table.colName')}</Td>
            <Td style={{ width: `55px` }}>{t('statistics.table.colGender')}</Td>
            <Td style={{ width: `98px` }}>{t('statistics.table.colBirth')}</Td>
            <Td style={{ width: `114px` }}>{t('statistics.table.colPhone')}</Td>
            <Td style={{ width: `103px` }}>{t('statistics.table.colMembership')}</Td>
          </HeadTr>
        </Head>
      </Table>
      <Table>
        <Body>
          {
            data.map((data, index) => (
              <BodyTr key={index} onClick={() => onClickMemberInfo(data)}>
                <Td style={{ width: `60px`, marginLeft: '8px', overflow: 'hidden' , whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {data.name}
                </Td>
                <Td style={{ width: `56px`, marginLeft: '8px' }}>
                  {data.gender === 'male' ? t('statistics.male') : t('statistics.female')}
                </Td>
                <Td style={{ width: `98px` }}>
                  {formatBirthDay(data.birthDay)}
                </Td>
                <Td style={{ width: `114px` }}>
                  {calcPhone(data)}
                </Td>
                <Td style={{ width: `80px`, overflow: 'hidden' , whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {data.membershipName}
                </Td>
              </BodyTr>
            ))
          }
        </Body>
      </Table>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Table = styled.table`
  display: flex;
  flex-direction: column;
`;

const Head = styled.thead`

`;

const Body = styled.tbody`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // width: 464px;
  width: 100%;
  height: 200px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		// height: 92px;
		background-color: ${props => props.theme.scrollBar};
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
    // height: 439px;
		// border: 4px solid transparent;
		background-color: ${props => props.theme.subackground};
		border-radius: 200px;
	}
`;

const HeadTr = styled.tr`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: 32px;

  margin-top: 16px;
  border-radius: 8px 8px 0 0;
  background-color: ${props => props.theme.line};
`;

const BodyTr = styled.tr`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  width: 100%;

  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.background};
  }
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  height: 36px;

  color: ${props => props.theme.subText};
`;